import { useEffect } from "react";
import { getToken } from "../../graphql/token";

export default function Root() {
  const token = getToken();

  useEffect(() => {
    // if (!slider) {
    //   window.location.href = "/signin";
    // } else {
    if (!token) {
      window.location.href = "/signin";
    } else {
      window.location.href = "/jobs";
    }
    // }
    // eslint-disable-next-line
  }, []);

  return null;
}
